import { every } from '@sama/micro-dash';
import { ShapeState } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { ShapeFilter } from '../../../cross-team-shared/state/abstract-sensor-content-state';

/** @deprecated used for old projects without objects */
export function applyFilters(
  shape: ShapeState | undefined,
  filters: ShapeFilter[],
) {
  // fix me if you change this code
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
  if (!shape || !shape.tags) {
    return true;
  }
  return every(filters, (shapeFilter) => {
    const answerOptionName = shape.tags[shapeFilter.outputName] || 'none';
    return !shapeFilter.filterNames.includes(answerOptionName);
  });
}
